module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_footer_image_04-96861594c3208394c40703784686afbe.jpg";